module.exports = __webpack_public_path__ + "img/HK.c039180d.svg";